import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SkillCard from "./SkillCard.js"

import bash from "../assets/skills/bash.svg"
import linux from "../assets/skills/linux.svg"
import python from "../assets/skills/python.svg"
import go from "../assets/skills/golang.png"
import kubernetes from "../assets/skills/kubernetes.svg"
import ansible from "../assets/skills/ansible.svg"
import docker from "../assets/skills/docker.svg"
import node from "../assets/skills/nodejs.svg"
import dotnet from "../assets/skills/net.png"
import otel from "../assets/skills/otel.png"
import dynatrace from "../assets/skills/dynatrace.svg"
import helm from "../assets/skills/helm.png"
import powershell from "../assets/skills/powershell.png"
import argocd from "../assets/skills/argocd.png"
import copilot from "../assets/skills/githubcopilot.png"


import hr from "../assets/curve-hr.svg"

export default function Skills() {
    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1
      };

    return (
        <div id="skills" className="mt-4 text-white">
            <h1 className="text-2xl font-bold">Skills</h1>
            <p className="font-light text-gray-400">Here are some of my skills</p>

            <div className="mt-4">
                <Slider {...settings}>
                <SkillCard name="CentOS/Debian/Ubuntu" experience="4 years" img={linux} />
                <SkillCard name="Kubernetes" experience="4 years" img={kubernetes} />
                <SkillCard name="Helm" experience="4 years" img={helm} />
                <SkillCard name="ArgoCD" experience="4 years" img={argocd} />
                <SkillCard name="Docker" experience="4 years" img={docker} />
                <SkillCard name="PowerShell" experience="4 years" img={powershell} />
                <SkillCard name="Bash" experience="4 years" img={bash} />
                <SkillCard name="Node.js" experience="4 years" img={node} />
                <SkillCard name=".NET" experience="4 years" img={dotnet} />
                <SkillCard name="Ansible" experience="4 years" img={ansible} />
                <SkillCard name="Golang" experience="1 years" img={go} />
                <SkillCard name="Python" experience="1 years" img={python} />
                <SkillCard name="OpenTelemetry" experience="1 years" img={otel} />
                <SkillCard name="Dynatrace" experience="1 years" img={dynatrace} />
                <SkillCard name="GitHub Copilot" experience="1 years" img={copilot} />
                </Slider>
            </div>
            <img src={hr} className="w-full mt-8 md:h-3" alt="hr" />
        </div>
    )
}